'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { routing } from '@/i18n/routing';
import config from '@/api/global';
import getFontByLocale from '@/functions/getFontByLocale';
import styles from './global-error.module.css';

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  const pathname = usePathname();
  const deafaultLocale = 'fa';
  const [localeValue, setLocaleValue] = useState(deafaultLocale);
  const [messages, setMessages] = useState<{
    common?: { errorPageTitle: string; errorPageText: string; tryAgain: string };
  }>({});

  useEffect(() => {
    console.error(error);
  }, [error]);

  useEffect(() => {
    const segments = (pathname || '').split('/').filter(Boolean);
    const supportedLocales = routing?.locales || [deafaultLocale];
    const locale =
      segments[0] && supportedLocales.includes(segments[0] as any) ? segments[0] : deafaultLocale;
    setLocaleValue(locale);

    import(`@/messages/${locale}/general.json`)
      .then((mod) => setMessages(mod.default))
      .catch(() => {});
  }, [pathname]);

  const fontClass = getFontByLocale(localeValue);
  const common = messages?.common;

  return (
    <html lang={localeValue} dir={config.isRTL(localeValue) ? 'rtl' : 'ltr'} className={fontClass}>
      <body>
        <div
          className={`${styles.wrapper} ${config.isRTL(localeValue) ? styles.rtl : styles.ltr}`}
        >
          <h1 className={styles.title}>{common?.errorPageTitle || 'مشکلی پیش آمد'}</h1>
          <p className={styles.text}>
            {common?.errorPageText || 'در بارگذاری این صفحه خطایی رخ داد. لطفاً دوباره تلاش کنید.'}
          </p>
          <button className={styles.button} onClick={() => reset()}>
            {common?.tryAgain || 'تلاش مجدد'}
          </button>
        </div>
      </body>
    </html>
  );
}
